module.exports = __webpack_public_path__ + "static/media/sams-club.9784c553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/sams-club.jpg
// module id = 1321
// module chunks = 0